import { fetchSsrHtml } from "../../core/common/ssr-utils.js";
import { getSsrBaseUrl } from "./coursesu-env.js";
import { getPosExtId } from "./utils.js";

const CORE_HTML_ENDPOINT = "/v3/core";

/**
 * Load the v3 core runtime when no feature SSR fragment is used.
 */
export async function injectCore(headers) {
  try {
    const html = await fetchSsrHtml(CORE_HTML_ENDPOINT, headers, { store_id: getPosExtId() }, getSsrBaseUrl());
    document.head.insertAdjacentHTML("beforeend", html);
  } catch (err) {
    console.error("[CoursesU] core SSR injection failed", err);
  }
}
